export const styleTableGlobal = {
  headerBg: '#E8E7EC',
  borderRadiusLG: 0,
  boxShadow: '0px 1px 0px 0px #0000000A',
  padding: 9,
};
